import { render, staticRenderFns } from "./AddSeguroicontratarPage.vue?vue&type=template&id=a3b2b3e4"
import script from "./AddSeguroicontratarPage.vue?vue&type=script&lang=js"
export * from "./AddSeguroicontratarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports